import { useContext, useCallback } from "react";
import { useSelector } from "react-redux";
import update from "immutability-helper";
import { FranqueadosContext } from "@/context/franqueados/franqueados";
import api, { makeOptions } from "@/services/api";

import toastify from "@/services/toastify";

const useFranqueados = () => {
  const { data: user } = useSelector(state => state.auth);
  const [state, setState] = useContext(FranqueadosContext);

  function _setLoading(loading) {
    setState(state => {
      return update(state, {
        loading: { $set: loading }
      });
    });
  }

  function _setData(data) {
    setState(state => {
      return update(state, {
        data: { $set: data }
      });
    });
  }

  async function fetchFranqueados() {
    _setLoading(true);
    const endpoint = `franqueados/publico`;
    const { data: response } = await api.get(endpoint, makeOptions(user));
    _setLoading(false);
    if (response.success) {
      _setData(response.data);
    } else {
      toastify("Erro ao buscar franqueados", "error");
    }
  }

  async function fetchFranqueado(franqueadoId) {
    _setLoading(true);
    const endpoint = `franqueados/${franqueadoId}`;
    const { data: response } = await api.get(endpoint, makeOptions(user));
    _setLoading(false);
    if (response.success) {
      return response.data;
    } else {
      toastify("Erro ao buscar franqueado", "error");
    }
  }

  async function fetchContaBancaria(franqueadoId) {
    try {
      const endpoint = `franqueados/conta-bancaria/franqueado/${franqueadoId}`;
      const { data: response } = await api.get(endpoint, makeOptions(user));
      if (response.success) {
        return response.data;
      }
      return [];
    } catch (error) {
      console.error("Erro ao buscar conta bancária:", error);
      return [];
    }
  }

  async function createContaBancaria(franqueadoId, data) {
    const formattedData = {
      franqueado_id: franqueadoId,
      ...data
    };
    const endpoint = `franqueados/conta-bancaria`;
    const { data: response } = await api.post(
      endpoint,
      formattedData,
      makeOptions(user)
    );
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || "Erro ao criar conta bancária");
  }

  async function updateContaBancaria(contaId, data) {
    const endpoint = `franqueados/conta-bancaria/${contaId}`;
    const { data: response } = await api.put(endpoint, data, makeOptions(user));
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || "Erro ao atualizar conta bancária");
  }

  const fetchBancos = useCallback(async () => {
    try {
      const endpoint = `cora/listar-bancos`;
      const { data: response } = await api.get(endpoint, makeOptions(user));
      if (response.success) {
        return response.data.banks;
      }
      return [];
    } catch (error) {
      console.error("Erro ao buscar bancos:", error);
      return [];
    }
  }, [user]);

  return {
    fetchFranqueados,
    fetchFranqueado,
    fetchContaBancaria,
    createContaBancaria,
    updateContaBancaria,
    fetchBancos,
    franqueados: state.data,
    loading: state.loading
  };
};

export { useFranqueados };
